import { PageShell } from "../components/PageShell";
import DiagnosticSection from "../components/DiagnosticSection";

export default function DiagnosticPage() {
  return (
    <PageShell testid="diagnostic-page">
      <DiagnosticSection />
    </PageShell>
  );
}
